module.exports = __webpack_public_path__ + "img/homeTitle.933e3dad.png";